import { AdyenPaymentMethodType, AdyenPaymentMethodVerificationStatus } from "../Transaction";

export enum AutoCollectWaitOptions {
  Earlier = "earlier",
  Later = "later"
}

export interface AdyenPartnerConfiguredPaymentMethodView {
  id: number;
  type: AdyenPaymentMethodType;
  verification_status: AdyenPaymentMethodVerificationStatus;
  active: boolean;
  is_surcharges_fee_enable: boolean;
  surcharges_fee_description?: string;
  surcharges_fee_percentage?: number;
  surcharges_fee_fixed?: number;
  created_at: string;
  updated_at: string;
}

export interface PostmarkSenderSignatureView {
  id: number;
  postmark_id?: number;
  domain_name: string;
  return_path: string;
  dkim_pending_host: string;
  dkim_pending_text_value: string;
  dkim_verified: boolean;
  return_path_verified: boolean;
  is_confirmed: boolean;
  sender_email?: string;
}

export interface RichSettings {
  branding_company_name: string;
  branding_company_logo_s3_url?: string;
  email_button_color: string;
  email_link_color: string;
  include_invoice_pdf_in_emails: boolean;
  payment_button_color: string;
  client_creation_automated: boolean;
  email_days_to_repeat_until_due_date: number;
  email_days_to_send_first_reminder_before_due_date: number;
  email_overdue_payments_enabled: boolean;
  email_upcoming_due_date_enabled: boolean;
  payment_auto_collect_limit: number;
  payment_auto_collect_limit_enabled: boolean;
  payment_charge_statement_descriptor: string;
  payment_custom_field_filter_enabled: boolean;
  payment_default_auto_collect_based_on_custom_field: boolean;
  disable_payout_reconciliation: boolean;
  payment_wait_days_until_due_date: number;
  payment_wait_x_days_earlier_or_later: AutoCollectWaitOptions;
  errors: string[];
  adyen_partner_configured_payment_methods: AdyenPartnerConfiguredPaymentMethodView[];
  postmark_sender_signatures: PostmarkSenderSignatureView[];
  available_custom_fields: string[];
  selected_custom_field?: string;
  delay_invoice_email_option: DelayInvoiceEmailOptions;
  delay_invoice_email_enabled: boolean;
  delay_invoice_email_seconds_after_creation: number;
  delay_invoice_email_every_day_at: number;
  delay_invoice_email_meridiem: Meridiem;
}

export enum DelayInvoiceEmailOptions {
  ScheduleAfter = "schedule_after",
  EveryDay = "every_day"
}

export enum Meridiem {
  AM = "AM",
  PM = "PM"
}

export interface SettingsPatch {
  branding_company_name?: string;
  branding_company_logo_s3_url?: string;
  email_button_color?: string;
  email_link_color?: string;
  include_invoice_pdf_in_emails?: boolean;
  payment_button_color?: string;
  client_creation_automated?: boolean;
  email_days_to_repeat_until_due_date?: number;
  email_days_to_send_first_reminder_before_due_date?: number;
  email_overdue_payments_enabled?: boolean;
  email_upcoming_due_date_enabled?: boolean;
  payment_auto_collect_limit?: number;
  payment_auto_collect_limit_enabled?: boolean;
  payment_charge_statement_descriptor?: string;
  payment_custom_field_filter_enabled?: boolean;
  payment_default_auto_collect_based_on_custom_field?: boolean;
  payment_custom_field_disable_and_delete?: boolean;
  disable_payout_reconciliation?: boolean;
  payment_wait_days_until_due_date?: number;
  payment_wait_xdays_earlier_or_later?: AutoCollectWaitOptions;
  adyen_partner_configured_payment_methods?: AdyenPartnerConfiguredPaymentMethodView[];
  postmark_sender_signatures?: PostmarkSenderSignatureView[];
  selected_custom_field?: string;
  delay_invoice_email_option?: DelayInvoiceEmailOptions;
  delay_invoice_email_enabled?: boolean;
  delay_invoice_email_seconds_after_creation?: number;
  delay_invoice_email_every_day_at?: number;
  delay_invoice_email_meridiem?: Meridiem;
}

export enum PaymentsEmailReason {
  FirstPayment = "first_payment",
  UpcomingPayment = "upcoming_payment",
  PaymentOverdue = "payment_overdue",
  PaymentReminder = "payment_reminder",
  RequestPaymentMethod = "request_payment_method"
}

export interface PaymentEmailBodyView {
  id: number;
  created_at: Date;
  updated_at: Date;
  reason: PaymentsEmailReason;
  salutation: string;
  subject: string;
  body: string;
  signature: string;
}

export interface PaymentsAutoCollectFilterValue {
  id: number;
  customer_id: number;
  created_at: Date;
  updated_at: Date;
  filter: string;
}
